export const useGetUserTimeZone = () => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  return { timeZone };
};
